/**
 * 微前端（micro-app）子应用宿主路由，统一收在 views/micro 下。
 *
 * 约定：
 *   - 页面路由统一为 /pages-xxxx/*（baseroute=/pages-xxxx），通配路由交给子应用内部接管；
 *   - 子应用资源入口统一为 /micro-assets/xxx（同源相对路径，返回 html，由 nginx 按环境代理）；
 *   - 宿主页无 newCode，meta.intermediate 标记为中间页，跳过 beforeEach 的页面鉴权。
 *
 * 新增第 N 个子应用：在此数组加一条 /pages-xxx/* + 对应宿主页组件即可，router.js 无需改动。
 */
export const microRoutes = [
  // 出库子应用宿主（micro-app），参考 scg-fe 的 pages-lv
  {
    path: '/pages-outbound/*',
    name: 'pages-outbound',
    // cache: 切到主应用其他菜单再切回时，宿主页进入 keep-alive；列表查询条件还依赖子应用自己的 keep-alive
    meta: { intermediate: true, cache: true },
    component: () => import('@/views/micro/pagesOutbound.vue')
  }
]
